// VST Custom JS
const root = document.documentElement;
const footer_sections = document.querySelectorAll('.shopify-section-group-footer-group');
const menu_drawer_utility_height = document.querySelector('.menu-drawer__utility-links');
const debounce_delay_mm = 150;

let vst_fh = 0;
footer_sections.forEach(section => { vst_fh += section.offsetHeight; });
root.style.setProperty('--body-height', document.body.offsetHeight + 'px');
root.style.setProperty('--footer-height', vst_fh + 'px');
root.style.setProperty('--mobile-util-height', (menu_drawer_utility_height.offsetHeight / 1.5) + 'px');

function debounce(fn, delay) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}
const vst_handleResize = debounce((entries) => {
  root.style.setProperty('--body-height', document.body.offsetHeight + 'px');
  root.style.setProperty('--footer-height', vst_fh + 'px');
  root.style.setProperty('--mobile-util-height', (menu_drawer_utility_height.offsetHeight / 1.5) + 'px');
}, debounce_delay_mm);

const window_observer = new ResizeObserver(vst_handleResize);
window_observer.observe(root);
